<template>
    <div class="vx-card" id="multiple-products">
        <div class="titles" style="display:block" >
            <span class="title-style modify-title mb-2" >
                Introduce los capitales que consideres más adecuados
            </span>

            <div v-if="offerCalculatedResponse" style= "display:contents">
                <span class="error-text-center" v-if="offerCalculatedResponse.validate == false" >
                    <label class="error-text-center"  style="font-weight:bold" :key="index" v-for="(msg, index) in offerCalculatedResponse.errorsInfo.errors">{{ msg }}</label>
                </span>
                <span class="error-text-center" v-if="errorCond" >
                    <label class="error-text-center" style="font-weight:bold" :key="index_msg" v-for="(text, index_msg) in error_msg">{{ text }}</label>
                </span>
            </div>
        </div>

        <div class="vx-col mt-3 red-border">
            <div class="pb-2 pt-1 mt-2" id="titles">
                <img src="../../../../assets/images/pages/eCommerce/umbrella.png">
                <span class="packName">{{commercialOffer.literal}}</span><br>
                <span class="packPrima">{{offerCalculated.receipt.toFixed(2).replace('.',',')}}</span>
                <span class="packUnits"> €/{{getPaymentMethod()}}</span>
            </div>
           
            <div class="vx-row product align" :key="indexCover" v-for="(cover, indexCover) in offerCalculated.covers" @click="focusOff()">
                    <div class="vx-col question-cell" v-if="cover.fieldType == 'subs'" style="align-items:left">
                        <div class="vx-row" style="margin-left: 0px">
                            <label class="question-label">{{cover.literal}}
                                <div v-if="tooltips">
                                    <div class="vx-col tooltip ml-2" v-if="tooltips.filter(x => x.literal == cover.literal)[0].explainTextCover" style="vertical-align:middle">
                                        <vs-icon class="clickable-icon" radius color="primary" type="flat" size="small" icon="helpcircle" style="opacity:0.6"></vs-icon>
                                        <span class="tooltiptext">{{tooltips.filter(x => x.literal == cover.literal)[0].explainTextCover}}</span>
                                    </div>
                                </div>
                            </label>
                            
                        </div>
                        <div class="vx-row">
                            <div class="vx-col config-cell" id="period">
                                <label class="question-label" v-if="cover.period == 0" style="opacity:0.9" id="label">¿Durante cuanto tiempo?</label>
                                <label class="question-label" v-else style="opacity:0.9" id="label">Periodo de cobertura:</label>

                                <md-field style="text-align:left" id="period-selector">
                                    <md-select
                                        name="offetType"
                                        v-validate="'required'"
                                        class="vselect-style"
                                        v-model.number="cover.period"
                                        @input="setSubsCover(cover)"
                                        >

                                        <md-option class="md-body-1"
                                            v-for="(item,indexRb) in cover.fieldValuesLiterals"
                                            :key="indexRb"
                                            :value="item"
                                            :text="item">{{item}} días</md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <div class="vx-col config-cell">
                                <label class="question-label" v-if="cover.coverCode == ''" style="opacity:0.9" id="label">¿Con qué franquicia?</label>
                                <label class="question-label" v-else style="opacity:0.9" id="label">Franquicia seleccionada:</label>

                                <md-field style="text-align:left" id="franchise-selector">
                                    <md-select
                                        name="offetType"
                                        v-validate="'required'"
                                        class="vselect-style "
                                        v-model="cover.coverCode"
                                        @input="setSubsCover(cover)"
                                        >

                                        <md-option class="md-body-1"
                                            v-for="(sub,indexSub) in cover.subsCover"
                                            :key="indexSub"
                                            :value="sub"
                                            :text="cover.subsCoverValues[indexSub]">{{cover.subsCoverValues[indexSub]}}</md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                    </div>

                    <div class="vx-col question-cell pr-0 " v-else-if="cover.fieldType == 'cond' && cover.coverCategory">
                        <div class="vx-row label-switch">
                            <label class="question-label">{{cover.literal}}
                                <div v-if="tooltips">
                                    <div class="vx-col tooltip ml-2" v-if="tooltips.filter(x => x.literal == cover.literal)[0].explainTextCover" style="vertical-align:middle">
                                        <vs-icon class="clickable-icon" radius color="primary" type="flat" size="small" icon="helpcircle" style="opacity:0.6"></vs-icon>
                                        <span class="tooltiptext">{{tooltips.filter(x => x.literal == cover.literal)[0].explainTextCover}}</span>
                                    </div>
                                </div> 
                            </label>

                            <vs-switch 
                                v-if="cover.coverDepend != 'MAIN'"
                                :disabled="!cover.switchEnabled"
                                v-model="cover.switch"
                                @click="changeConditionalSwitch(cover)">
                            </vs-switch>
                        </div>
                    
                        <div v-if="cover.switchEnabled ">
                            <md-field class="condSelector" style="text-align:left" id="condSelector">
                                <!-- Applies to cover.coverCategory "Baremo" & "Franquicia" 
                                @input="setCondCoverPrueba(cover)"-->
                                <md-select 
                                    name="selector"
                                    v-validate="'required'"
                                    class="select-filter select-question-filter "
                                    v-model="cover.coverCode"
                                    @input="setCondCoverSelect(cover)"
                                    >
                                    <md-option class="md-body-1"
                                        v-for="(item,indexRb) in cover.options"
                                        :key="indexRb"
                                        :value="item.value"
                                        :text="item.label">{{item.label}}
                                        </md-option>
                                </md-select>
                            </md-field>
                        </div>
                    </div>

                    <div class="vx-col question-cell pr-0 " v-else-if="cover.fieldType == 'chkcond' && cover.coverCategory">
                        <div class="vx-row label-switch">
                            <label class="question-label">{{cover.literal}}
                                <div v-if="tooltips">
                                    <div class="vx-col tooltip ml-2" v-if="tooltips.filter(x => x.literal == cover.literal)[0].explainTextCover" style="vertical-align:middle">
                                        <vs-icon class="clickable-icon" radius color="primary" type="flat" size="small" icon="helpcircle" style="opacity:0.6"></vs-icon>
                                        <span class="tooltiptext">{{tooltips.filter(x => x.literal == cover.literal)[0].explainTextCover}}</span>
                                    </div>
                                </div> 
                            </label>

                            <vs-switch 
                                v-if="cover.coverDepend != 'MAIN'"
                                :disabled="!cover.switchEnabled"
                                v-model="cover.switch"
                                @click="changeConditionalSwitch(cover)">
                            </vs-switch>
                        </div>
                    
                        <div v-if="cover.switchEnabled && cover.coverCategory != 'Asistencia Sanitaria' ">
                            <md-field class="condSelector" style="text-align:left" id="condSelector">
                                
                                <md-select 
                                    name="selector"
                                    v-validate="'required'"
                                    class="select-filter select-question-filter "
                                    v-model="cover.coverCode"
                                    @input="setChkCondCoverSelect(cover)"

                                    >
                                    <md-option class="md-body-1"
                                        v-for="(item,indexRb) in cover.options"
                                        :key="indexRb"
                                        :value="item.value"
                                        :text="item.label">{{item.label}}
                                        </md-option>
                                </md-select>
                            </md-field>
                        </div>
                    </div>

                    <div class="vx-col question-cell pr-0 " v-else-if="cover.fieldType == 'select'">
                        <div class="vx-row label-switch">
                            <label class="question-label">{{cover.literal}}
                                <div v-if="tooltips">
                                    <div class="vx-col tooltip ml-2" v-if="tooltips.filter(x => x.literal == cover.literal)[0].explainTextCover" style="vertical-align:middle">
                                        <vs-icon class="clickable-icon" radius color="primary" type="flat" size="small" icon="helpcircle" style="opacity:0.6"></vs-icon>
                                        <span class="tooltiptext">{{tooltips.filter(x => x.literal == cover.literal)[0].explainTextCover}}</span>
                                    </div>
                                </div> 
                            </label>
                            <vs-switch 
                                v-if="cover.coverDepend != 'MAIN'"
                                :disabled="!cover.switchEnabled"
                                v-model="cover.switch"
                                @click="changeConditionalSwitch(cover)">
                            </vs-switch>
                        </div>
                    
                    </div>

                    <div class="vx-col question-cell pr-0 " v-else-if="cover.fieldType == 'auto'">
                        <div class="vx-row label-switch">
                            <label class="question-label">{{cover.literal}}
                                <div v-if="tooltips">
                                    <div class="vx-col tooltip ml-2" v-if="tooltips.filter(x => x.literal == cover.literal)[0].explainTextCover" style="vertical-align:middle">
                                        <vs-icon class="clickable-icon" radius color="primary" type="flat" size="small" icon="helpcircle" style="opacity:0.6"></vs-icon>
                                        <span class="tooltiptext">{{tooltips.filter(x => x.literal == cover.literal)[0].explainTextCover}}</span>
                                    </div>
                                </div> 
                            </label>
                            <vs-switch 
                                v-if="cover.coverDepend != 'MAIN'"
                                :disabled="true"
                                v-model="cover.switch"
                                @click="changeConditionalSwitch(cover)">
                            </vs-switch>
                        </div>
                    
                    </div>

                    <div class="vx-col question-cell" v-else-if="cover.fieldType != 'hiddencond'">
                        <div class="vx-row label-switch">
                            <label class="question-label">{{cover.literal}}
                                <div v-if="tooltips">
                                    <div class="vx-col tooltip ml-2" v-if="tooltips.filter(x => x.coverCode == cover.coverCode)[0].explainTextCover" style="vertical-align:middle">
                                        <vs-icon class="clickable-icon" radius color="primary" type="flat" size="small" icon="helpcircle" style="opacity:0.6"></vs-icon>
                                        <span class="tooltiptext">{{tooltips.filter(x => x.coverCode == cover.coverCode)[0].explainTextCover}}</span>
                                    </div>
                                </div>
                            </label>
                            
                            <vs-switch 
                                v-if="cover.coverDepend != 'MAIN'"
                                :disabled="!cover.switchEnabled"
                                v-model="cover.switch"
                                @click="changeConditionalSwitch(cover)">

                            </vs-switch>
                        </div>
                        
                    </div>
                    
                    <div class="vx-col answer-cell" v-if="cover.coverDepend == 'MAIN' && cover.fieldType != 'select'">
                        <md-field >
                            <md-input
                                v-on:keypress="NumbersOnly"
                                v-on:blur="setNumCover(cover)"
                                name="literalCover"
                                val-icon-danger="warning"
                                class="w-full input-capital"
                                v-validate="'required'"
                                style="padding-bottom:0px"
                                @input="includeCommas(cover)"
                                @change="setNumCover(cover)"

                                v-model="cover.capitalText"
                                :style="{fontWeight: cover.capitalText != 0 ? '520' : 'normal'}"
                            ></md-input>
                            <span class="md-suffix"> €</span>
                        </md-field>
                    </div>

                    <div class="vx-col answer-cell " v-else-if="setFieldType(cover.fieldType) == 'select'"
                    :style="{visibility: cover.switchEnabled || cover.coverDepend == 'MAIN' ? 'visible' : 'hidden'}" >
                        <md-field class="md-body-1" >
                            <md-select
                                name="offetType"
                                class="w-full"
                                v-validate="'required'"
                                @input="selectInput(cover)"
                                v-model="cover.capital"
                                >
                                <md-option class="md-body-1"
                                    v-for="(item,indexRb) in cover.fieldValuesLiterals"
                                    :key="indexRb"
                                    :value="cover.fieldValues[indexRb]"
                                    :text="item">{{item}} €</md-option>

                            </md-select>
                        </md-field>
                    </div>

                    <div class="vx-col answer-cell" v-else-if ="cover.fieldType == 'chkcond'"
                        :style="{visibility: cover.switchEnabled ? 'visible' : 'hidden'}" >

                        <md-field v-if="cover.coverCategory == 'Asistencia Sanitaria'">
                            <md-select 
                                name="asistenciaSanitaria"
                                v-validate="'required'"
                                class="select-filter select-question-filter"
                                v-model="cover.coverCode"
                                @input="setChkCondCoverSelect(cover)"

                                >
                                <md-option class="md-body-1"
                                    v-for="(item,indexRb) in cover.options"
                                    :key="indexRb"
                                    :value="item.value"
                                    :text="item.label">{{item.label}}</md-option>
                            </md-select>
                        </md-field>
                        
                        <md-field v-else-if="cover.coverCategory != 'Franquicia' && cover.coverCategory !=''">
                            <md-input
                                v-on:keypress="NumbersOnly"
                                v-on:blur="setNumCover(cover)"
                                name="chkcondCover"
                                val-icon-danger="warning"
                                class="w-full input-capital"
                                v-validate="'required'"
                                style="padding-bottom:0px"
                                @input="includeCommas(cover)"
                                @change="setNumCover(cover)"

                                v-model="cover.capitalText"
                                :style="{fontWeight: cover.capitalText != 0 ? '520' : 'normal'}"
                            ></md-input>
                            <span class="md-suffix"> €</span>
                        </md-field>
                    </div>
                    
                    <div class="vx-col answer-cell" v-else-if ="setFieldType(cover.fieldType) != 'checkbox' && cover.fieldType != 'hiddencond' && cover.fieldType != 'auto'"
                        :style="{visibility: cover.switchEnabled ? 'visible' : 'hidden'}" >
                        <md-field>
                            <md-input
                                v-on:keypress="NumbersOnly"
                                v-on:blur="setNumCover(cover)"
                                name="literalCover"
                                val-icon-danger="warning"
                                class="w-full input-capital"
                                v-validate="'required'"
                                style="padding-bottom:0px"
                                @input="includeCommas(cover)"
                                @change="setNumCover(cover)"

                                v-model="cover.capitalText"
                                :style="{fontWeight: cover.capitalText != 0 ? '520' : 'normal'}"
                            ></md-input>
                            <span class="md-suffix"> €</span>
                        </md-field>
                    </div>
                     
            </div>

            <div class="info-interested-div">
                <!-- Important the order of buttons, as direction is row-reverse: izq a dcha 
                To avoid movement of buttons when i button not showed  -->
                <vs-button
                    class="rounded-button right-button"
                    @click="goToThirdStep()"
                    >
                    Me interesa
                </vs-button>
                <vs-button
                    class="info-button"
                    @click="showCoverageChart()"
                    :style="{display: error_msg.length == 0 && offerCalculated.receipt != 0 && offerCalculatedResponse.validate == true ? 'inline' : 'none'}"
                    >
                      &#9432;
                </vs-button>

            </div>

            <div v-if="coveragechart">
                <vs-popup  class="con-vs-popup coverage-popup" :active.sync="coverageChartPop">
                <coverage-chart-component
                    v-bind:coverageChart="coveragechart.packOffer[0]"
                    v-bind:dataTable="dataTablePackage"
                    v-bind:coverageChartPop="coverageChartPop"
                    @closeCoverageChartPop="closeCoverageChartPop"
                ></coverage-chart-component>
                    </vs-popup>
            </div>
        </div>
        
        <navegation-buttons id="buttons"
            v-bind:code="code"
            v-bind:previus="previus">
        </navegation-buttons>
        <!-- <vs-popup  class="con-vs-popup bg-box-gradient-popup"  title="¿Hablamos?" :active.sync="callServicePopup">
            <call-service-popup
                v-bind:callServicePopup="callServicePopup"
                v-bind:callServiceType="callServiceType"
                @closeCallServicePopup="closeCallServicePopup"
            >
            </call-service-popup>
        </vs-popup> -->

        <!-- <div id="buttons-2" class="form-width" style="display:inline-block">
            <div  class="box-buttons mt-10">
                <div class="back-button no-fill-button">
                    <vs-button
                    class="vs-button previous-product"
                    @click="goToPreviusStep()"
                    >
                    Anterior
                    </vs-button>
                </div>
                <div class="call-button no-fill-button">
                    <vs-button
                        @click="callService()"
                    >
                    <img src="../../../../assets/images/logo/call-phone-icon.png" width="15px" height="15px"/>
                        Solicitar llamada
                    </vs-button>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
/* eslint-disable */
import VxCard from '../../../../components/vx-card/VxCard.vue'
import CoverageChartComponent from '../coverage-chart/CoverageChartComponent.vue'
import vSelect from 'vue-select'
import NavegationButtons from '../navegationButtons/NavegationButtons.vue'
// import CallServicePopup from '../../../components/eprevision-components/callServicePopup/CallServicePopup.vue';

// import VueCookies from 'vue-cookies'
// import "broadcastchannel-polyfill";
export default {
  components: { VxCard, 
                CoverageChartComponent,
                // CallServicePopup, 
                NavegationButtons ,
                vSelect},

    name: 'commercial-offer-multiple-products',
    props: {
        commercialOffer: Object,
        code: String,
        next: String,
        previus: String,
    },
    data() {
        return {
            offerCalculatedResponse: null,
            // callServiceType:"helpProcess",
            // callServicePopup: false,
            commercialOfferForm:null,
            commercialOfferResponse: null,
            dataStored: null,
            dataTablePackage: [],
             offerCalculated: {
                profession: "",
                bornDate: "",
                regime: "",
                paymentType:"",
                covers: [],
                primaNeta: 0,
                primaTotal: 0,
                taxs: 0,
                receipt: 0,
                productCover: ""
            },
            files: [],
            formattedCapital:"",
            packCommercialOffers:[],
            offerCalculatedResponse: {
                coversResult: [],
                errorsInfo:  [],
                productCover: "",
                validate:"",
            },
            coveragechart: null,
            coverageChartPop: false,
            tooltips: [],
            previousCovers: [],
            errorCond: false,
            error_msg: [],
            ready: false,
        }
    },
    created() {
        this.dataStored = JSON.parse(localStorage.getItem(this.code))

        if (this.dataStored.initialData) {
            this.commercialOfferResponse = this.dataStored.initialData
            this.commercialOfferResponse.age = this.dataStored.initialData.age
        }

        if(this.commercialOffer.singlePack) {
            this.tooltips = this.commercialOffer.singlePack
        }

        this.initForm()
    },

    methods: {
       initForm() {
           console.log("commercialOffer-form")

           let data = {
                bornDate: this.dataStored.initialData.age,
                profession: this.dataStored.initialData.profession,
                regime: this.dataStored.initialData.regime,
            }

           this.$http.post(process.env.VUE_APP_BROKER_API + '/commercialOffer-form/' + this.commercialOffer.code, data)
           .then((response) => {
                this.commercialOfferForm = response.data
                this.offerCalculated.covers = [];
                let subsCovers = false;
                let condFrCovers = false;
                let condBrCovers = false;

                let chkCondSelect = false;
                // let product = []

                //prepare the request object to complete with the form information by user
                this.commercialOfferForm.forEach(element => {
                    let cover;
                    switch ( element.fieldType) {
                        case "subs":

                            if (!subsCovers) {
                                cover = {
                                    literal: "",
                                    coverCode: "",
                                    fieldType: "",
                                    fieldValues: [],
                                    fieldValuesLiterals: [],
                                    capital: 0,
                                    capitalText: 0,
                                    productId: "",
                                    primaNeta:0,
                                    tax: 0,
                                    checkValue: "",
                                    period: 0,
                                    subsCover: [],
                                    coverCategory: "",
                                    subsCoverValues: [],
                                    order: null,
                                    coverDepend: "",
                                    switch: null,
                                    switchEnabled: null,

                                }

                                cover.capital = 0;
                               // cover.coverCode = element.code;
                                cover.literal = element.literal;
                                cover.fieldType = element.fieldType;
                                cover.productId = element.productId;
                                cover.coverDepend = element.coverDepend

                               if(element.coverDepend == "MAIN") {
                                    cover.switch = true
                                    cover.switchEnabled = true

                                } else {
                                    cover.switch = false
                                    cover.switchEnabled = false
                                }

                                if (element.coverCategory) {
                                    cover.coverCategory = element.coverCategory
                                }

                                if (element.fieldValues) {
                                    element.fieldValues.forEach(fieldValue => {
                                        cover.fieldValues.push(fieldValue)

                                    });
                                    element.fieldValuesLiterals.forEach(fieldValueLiteral => {
                                        cover.fieldValuesLiterals.push(fieldValueLiteral)
                                    });

                                }
                                // console.log(this.commercialOfferForm.filter(b => b.fieldType == element.fieldType && b.coverCategory == element.coverCategory))
                                // this.commercialOfferForm.filter(b => b.fieldType == element.fieldType && b.coverCategory == element.coverCategory).forEach(subCover => {

                                this.commercialOfferForm.forEach(subCover => {
                                    if (subCover.fieldType == "subs") {
                                        if (subCover.commercialName) {

                                            cover.subsCover.push(subCover.code)
                                            cover.subsCoverValues.push(subCover.commercialName)
                                        } else {
                                            cover.subsCover.push(subCover.code)
                                            cover.subsCoverValues.push(subCover.name)
                                        }
                                        cover.order = subCover.order
                                        
                                     }
                                 })
                                this.offerCalculated.covers.push(cover);
                                subsCovers = true;
                            }
                            break;

                        case  "cond":
                            // The different options of a cover are separated on endpoint -> to parse it correctly and avoid showing the same cover
                            // multiple times, we check if the literal is already present in array 
                            

                            if (element.coverCategory == "Franquicia"){
                                if (!condFrCovers) {
                                    
                                    cover = {
                                        literal: "",
                                        coverCode: "",
                                        fieldType: "",
                                        fieldValues: [],
                                        fieldValuesLiterals: [],
                                        capital: 0,
                                        capitalText: 0,
                                        productId: "",
                                        primaNeta:0,
                                        tax: 0,
                                        checkValue: "",
                                        period: 0,
                                        subsCover: [],
                                        subsCoverValues: [],
                                        options: [],
                                        order: null,
                                        coverDepend: "",
                                        switch: null,
                                        switchEnabled: null,
                                    }

                                    cover.capital = 0;
                                    // To avoid pre-selection of one option of Franquicia
                                    // cover.coverCode = this.commercialOfferForm.filter(x => x.fieldType  == "cond" && x.coverCategory == "Franquicia")[0].code;
                                    cover.literal = this.commercialOfferForm.filter(x => x.fieldType  == "cond" && x.coverCategory == "Franquicia")[0].literal;
                                    cover.coverCategory = this.commercialOfferForm.filter(x => x.fieldType  == "cond" && x.coverCategory == "Franquicia")[0].coverCategory;
                                    cover.fieldType = this.commercialOfferForm.filter(x => x.fieldType  == "cond" && x.coverCategory == "Franquicia")[0].fieldType;
                                    cover.productId = element.productId;
                                    cover.coverDepend = element.coverDepend

                                    if(element.coverDepend == "MAIN") {
                                        cover.switch = true
                                        cover.switchEnabled = true

                                    } else {
                                        cover.switch = false
                                        cover.switchEnabled = false
                                    }

                                    if (element.fieldValues) {
                                        element.fieldValues.forEach(fieldValue => {
                                            cover.fieldValues.push(fieldValue)

                                        });
                                        element.fieldValuesLiterals.forEach(fieldValueLiteral => {
                                            cover.fieldValuesLiterals.push(fieldValueLiteral)
                                        });
                                    }

                                    this.commercialOfferForm.filter(x => x.fieldType  == "cond" && x.coverCategory == "Franquicia").forEach(subCover => {

                                            let option = {
                                                label: subCover.name,
                                                value: subCover.code
                                            }

                                            if (subCover.commercialName) {

                                                option.label = subCover.commercialName
                                                option.value = subCover.code
                                            } else {
                                                option.label = subCover.name
                                                option.value = subCover.code
                                            }
                                            cover.options.push(option)

                                            cover.order = subCover.order
                                    })

                                    this.offerCalculated.covers.push(cover);
                                    condFrCovers = true;

                                }
                            } else if (element.coverCategory == "Baremo"){
                                if(!condBrCovers) {
                                    cover = {
                                        literal: "",
                                        coverCode: "",
                                        fieldType: "",
                                        fieldValues: [],
                                        fieldValuesLiterals: [],
                                        capital: 0,
                                        capitalText: 0,
                                        productId: "",
                                        primaNeta:0,
                                        tax: 0,
                                        checkValue: "",
                                        period: 0,
                                        subsCover: [],
                                        subsCoverValues: [],
                                        options: [],
                                        order: null,
                                        coverDepend: "",
                                        switch: null,
                                        switchEnabled: null,

                                    }

                                    cover.capital = 0;
                                    // To avoid pre-selection of one option of Baremo
                                    // cover.coverCode = this.commercialOfferForm.filter(y => y.fieldType  == "cond" && y.coverCategory == "Baremo")[0].code;
                                    cover.literal = this.commercialOfferForm.filter(y => y.fieldType  == "cond" && y.coverCategory == "Baremo")[0].literal;
                                    cover.coverCategory = this.commercialOfferForm.filter(y => y.fieldType  == "cond" && y.coverCategory == "Baremo")[0].coverCategory;
                                    cover.fieldType = this.commercialOfferForm.filter(y => y.fieldType  == "cond" && y.coverCategory == "Baremo")[0].fieldType;
                                    cover.productId = element.productId;
                                    cover.coverDepend = element.coverDepend;

                                    if(element.coverDepend == "MAIN") {
                                        cover.switch = true
                                        cover.switchEnabled = true

                                    } else {
                                        cover.switch = false
                                        cover.switchEnabled = false
                                    }


                                    if (element.fieldValues) {
                                        element.fieldValues.forEach(fieldValue => {
                                            cover.fieldValues.push(fieldValue)

                                        });
                                        element.fieldValuesLiterals.forEach(fieldValueLiteral => {
                                            cover.fieldValuesLiterals.push(fieldValueLiteral)
                                        });
                                    }

                                    this.commercialOfferForm.filter(y => y.fieldType  == "cond" && y.coverCategory == "Baremo").forEach(subCover => {

                                            let option = {
                                                label: subCover.name,
                                                value: subCover.code
                                            }

                                            if (subCover.commercialName) {
                                                option.label = subCover.commercialName
                                                option.value = subCover.code
                                            } else {
                                                option.label = subCover.name
                                                option.value = subCover.code
                                            }

                                            // ---------
                                            // Las invalideces de Baremo D rompen estándar de nomenclatura (en el estándar empiezan por INV, por ej: INVPERBE y no IPP)
                                            // Como las coberturas dependientes de invalideces filtran por INV, necesitamos que lo contenga en el código.
                                            // Añadido aquí a su código ( NO se puede modificar en ARPA por repercusiones en el cuadro de coberturas )
                                            // Quitar cuando se estandarice en la BBDD y ARPA
                                            if(option.value.includes('IPP')) {
                                                option.value = 'INV_' + subCover.code
                                            }

                                            // ---------

                                            cover.options.push(option)

                                            cover.order = subCover.order
                                    })

                                    this.offerCalculated.covers.push(cover);
                                    condBrCovers = true;

                                }

                            }
                            break;

                        case "select":

                            cover = {
                                literal: "",
                                coverCode: "",
                                fieldType: "",
                                fieldValues: [],
                                fieldValuesLiterals: [],
                                capital: 0,
                                capitalText: 0,
                                productId: "",
                                primaNeta:0,
                                tax: 0,
                                checkValue: "",
                                period: 0,
                                subsCover: [],
                                subsCoverValues: [],
                                coverCategory: "",
                                order: null,
                                coverDepend: "",
                                switch: null,
                                switchEnabled: null,
                            }

                            cover.coverCode = element.code;
                            cover.literal = element.literal;
                            cover.fieldType = element.fieldType;
                            cover.productId = element.productId;
                            cover.coverDepend = element.coverDepend;

                            if(element.coverDepend == "MAIN") {
                                cover.switch = true
                                cover.switchEnabled = true

                            } else {
                                cover.switch = false
                                cover.switchEnabled = false
                            }

                            if (element.coverCategory) {
                                cover.coverCategory = element.coverCategory
                            }

                            if (element.fieldValues) {
                                element.fieldValues.forEach(fieldValue => {
                                    cover.fieldValues.push(fieldValue)

                                });
                                element.fieldValuesLiterals.forEach(fieldValueLiteral => {
                                    cover.fieldValuesLiterals.push(fieldValueLiteral)
                                });
                            }
                            cover.order = element.order
                            this.offerCalculated.covers.push(cover);

                            break;

                        default:
                            cover = {
                                literal: "",
                                code: "",
                                fieldType: "",
                                fieldValues: [],
                                fieldValuesLiterals: [],
                                capital: 0,
                                capitalText: 0,
                                productId: "",
                                primaNeta:0,
                                tax: 0,
                                checkValue: "",
                                period: 0,
                                chkCondValue: null,
                                subsCover: [],
                                coverCategory: "",
                                subsCoverValues: [],
                                options: [],
                                order: null,
                                coverDepend: "",
                                switch: null,
                                switchEnabled: null,
                            }
                            
                            cover.capital = 0;
                            cover.coverCode = element.code;
                            cover.literal = element.literal;
                            cover.fieldType = element.fieldType;
                            cover.productId = element.productId;
                            cover.coverDepend = element.coverDepend;

                            if(element.coverDepend == "MAIN") {
                                cover.switch = true
                                cover.switchEnabled = true

                            } else if(element.coverDepend != "MAIN"){
                                cover.switch = false
                                cover.switchEnabled = false
                            }

                            if (element.coverCategory) {
                                cover.coverCategory = element.coverCategory
                            }

                            if (element.fieldValues) {
                                element.fieldValues.forEach(fieldValue => {
                                    cover.fieldValues.push(fieldValue)

                                });
                                element.fieldValuesLiterals.forEach(fieldValueLiteral => {
                                    cover.fieldValuesLiterals.push(fieldValueLiteral)
                                });
                            }

                            if(element.fieldType == 'hiddencond') {
                                cover.capital = 1
                                cover.capitalText = "1"
                                cover.switch = true
                            }

                            if(element.fieldType == "chk" || element.fieldType == "chkcond") {
                                if (!chkCondSelect && element.coverCategory == "Asistencia Sanitaria") {
                                    if ( element.fieldType == "chkcond" && element.coverCategory == "Asistencia Sanitaria"){
                                        cover.coverCode = ""

                                        this.commercialOfferForm.filter(y => y.fieldType  == "chkcond" && y.coverCategory == "Asistencia Sanitaria").forEach(subCover => {

                                            let option = {
                                                label: subCover.name,
                                                value: subCover.code
                                            }

                                            if (subCover.commercialName) {

                                                option.label = subCover.commercialName
                                                option.value = subCover.code
                                            } else {
                                                option.label = subCover.name
                                                option.value = subCover.code
                                            }

                                            cover.options.push(option)
                                            cover.order = subCover.order
                                        })

                                        this.offerCalculated.covers.push(cover);
                                        chkCondSelect = true
                                    }

                                } else if(element.coverCategory == "Franquicia") {

                                    cover.capital = 0;
                                    // To avoid pre-selection of one option of Baremo
                                    cover.coverCode = ""
                                    cover.literal = this.commercialOfferForm.filter(x => x.fieldType  == "chkcond" && x.coverCategory == "Franquicia")[0].literal;
                                    cover.coverCategory = this.commercialOfferForm.filter(x => x.fieldType  == "chkcond" && x.coverCategory == "Franquicia")[0].coverCategory;
                                    cover.fieldType = this.commercialOfferForm.filter(x => x.fieldType  == "chkcond" && x.coverCategory == "Franquicia")[0].fieldType;
                                    cover.productId = element.productId;

                                    this.commercialOfferForm.filter(x => x.fieldType  == "chkcond" && x.coverCategory == "Franquicia").forEach(subCover => {

                                        let option = {
                                            label: subCover.name,
                                            value: subCover.code
                                        }

                                        if (subCover.commercialName) {

                                            option.label = subCover.commercialName
                                            option.value = subCover.code
                                        } else {
                                            option.label = subCover.name
                                            option.value = subCover.code
                                        }
                                        cover.options.push(option)

                                        cover.order = subCover.order
                                    })

                                    if (this.offerCalculated.covers.filter(y => y.fieldType == cover.fieldType && y.coverDepend == cover.coverDepend && y.coverCategory == cover.coverCategory).length == 0) {
                                        this.offerCalculated.covers.push(cover);
                                        chkCondSelect = true

                                    }

                                } else if (this.commercialOffer.productsInfo) {

                                        let selectedProduct = this.commercialOffer.productsInfo.filter(a => a._id == element.productId)[0]

                                        cover.checkValue = selectedProduct.coberturas.filter(x => x.codigo == element.code)[0].calculo.valor

                                } else {
                                    cover.checkValue = 1
                                }
                            }


                            if (element.coverCategory != "Asistencia Sanitaria" && element.coverCategory != "Franquicia" ) {

                                cover.order = element.order
                                this.offerCalculated.covers.push(cover);
                            }
                        }

                
                })
            this.predetermineMainValues()
            })

        },

        predetermineMainValues(){
            // Predetermines value to length / 2 rounded upwards
            // eg. : if franchise 0, 5, 10, 15, 30 -> 5/2 = 2.5 & rounds to 3
            // Selects value in array (from 0 to 4) -> need to subtract 1 to get correct value
            // console.log(this.offerCalculated.covers)
            this.offerCalculated.covers.forEach(cover => {
                if(cover.coverDepend == "MAIN"){
                    if(cover.coverCode == "") {
                   
                        if(cover.fieldValues.length > 0) {
                            let selectedPeriod = Math.round(cover.fieldValues.length/2)
                            cover.period =  cover.fieldValues[selectedPeriod - 1]
                        }
                        
                        if(cover.subsCover.length > 0) { 
                            let selectedProduct = Math.round(cover.subsCover.length/2)
                            cover.coverCode =  cover.subsCover[selectedProduct - 1]
                        }
                    }
                }
            })
        },

        


        setNumCover(cover){ 
           
            // Activates/deactivates switches and refreshes capitals of dependent covers
                if(cover.capital != 0){
                    cover.switch = true
                    this.activateDependentSwitches(cover)
                } else {
                    cover.switch = false
                    this.deactivateDependentSwitches(cover)
                }
                
                this.refreshCapitalDependentCovers(cover)


                if(cover.fieldType == 'cond' ) {
                    // Takes into account "Franquicia" && "Baremo"
                    this.setCondCover(cover)

                } else if (cover.fieldType == 'subs') {
                    this.calculateOffer()

                } else if (cover.fieldType == 'select') {
                    this.cover.capital = parseFloat(cover.checkValue)
                    this.calculateOffer() 

                } else {
                    this.calculateOffer()
                }

        },

       
        refreshCapitalDependentCovers(mainCover){
            let coverDependent = this.offerCalculated.covers.filter(a => mainCover.coverCode.includes(a.coverDepend))

            coverDependent.filter(b => b.productId == mainCover.productId).forEach(element => {
                if(element.switch == true){
                    // Special coverCategories don't get values of MAIN cover -> we don't need to modify these, only
                    // the ones with no coverCategory
                    if((element.fieldType == 'chkcond' || element.fieldType == 'chk') && element.coverCategory == ""){
                        if(element.checkValue == 1) {
                            this.setChkCondCoverValue(element)

                        } else {
                            element.capital = mainCover.capital
                            element.capitalText = mainCover.capitalText
                        }
                    }
                }
            })
        },


       setSubsCover(cover){
                if (cover.period != "" && cover.coverCode != "" && cover.capital != 0) {
                    
                    this.calculateOffer()
                    this.activateDependentSwitches(cover)
            
                }
        },
        
        setCondCover(cover){
                if(cover.coverCode) {

                // IF Selector chosen & capital introduced
                    if (cover.capital > 0 || cover.capitalText != "0") {
                            this.errorCond = false
                            this.activateDependentSwitches(cover)

                            this.calculateOffer();

                        // IF Selector chosen & capital = 0
                        } else {
                            this.calculateOffer();
                            cover.switch = false
                        }

                // Assigns first option value if non has been assigned by client
                } else {
                    cover.coverCode = cover.options[0].value
                }
       },

        setCondCoverSelect(cover){
            
                if (cover.coverDepend != "MAIN") {
                    if(cover.switch == true && cover.capital != 0) {
                        this.calculateOffer()
                        this.activateDependentSwitches(cover)

                    }
                } else {
                    this.calculateOffer()
                    this.activateDependentSwitches(cover)
                }
        },

        setChkCondCoverSelect(cover){
                if(cover.coverCode) {
                    if(cover.coverCategory == "Asistencia Sanitaria"){
                        cover.code = cover.coverCode
                        let coverData = this.commercialOffer.productsInfo.filter(a => a._id == cover.productId)[0].coberturas.filter(x => x.codigo == cover.coverCode)[0]
                        cover.capital = coverData.calculo.valor
                        cover.capitalText = coverData.calculo.valor.toString()
                    } else {
                        cover.code = cover.coverCode
                        let coverDependsOn = this.offerCalculated.covers.filter(a => a.productId == cover.productId && a.coverCode == cover.coverDepend)[0]
                        
                        cover.capital = coverDependsOn.capital
                        cover.capitalText = coverDependsOn.capitalText

                    }

                    this.calculateOffer()

                }
        },

        setChkCondCoverValue(cover){
                cover.capital = 0
                cover.capitalText = "0"
                let productSelected = this.commercialOffer.productsInfo.filter(x => x._id == cover.productId)[0]
                let coverSelected = this.commercialOffer.productsInfo.filter(x => x._id == cover.productId)[0].coberturas.filter(y => y.codigo == cover.coverCode)[0]

                if(cover.chkCondValue != "0") {
                    if (coverSelected.calculo.calcPrimas){
                        cover.capital = 1
                        cover.capitalText = "1"

                    } else if (coverSelected.calculo.valor != null) {
                        cover.capital = coverSelected.calculo.valor
                        cover.capitalText = coverSelected.calculo.valor.toString()

                    } else {
                        coverSelected.calculo.campos.forEach(item =>{
                            if (this.offerCalculated.covers.filter(x => x.coverCode == productSelected.coberturas[item].codigo)[0]){

                                cover.capital += this.offerCalculated.covers.filter(x => x.coverCode == productSelected.coberturas[item].codigo)[0].capital
                            }
                        })
                        cover.capitalText = cover.capital.toString()
                    }
                }
        },

        changeConditionalSwitch(cover) {
            if(cover.switch == true) {
                // if switch is deactivated

                if(cover.fieldType == "chk"){
                    cover.chkCondValue = "0"
                }

                cover.capital = 0
                cover.capitalText = "0"

                this.deactivateDependentSwitches(cover)
                this.calculateOffer()

                if((cover.fieldType == "chkcond") && cover.coverCategory) {
                    cover.code = ""
                    cover.coverCode = ""
                    cover.checkValue = "0"
                }

            } else {

                // Predetermines value to length / 2 rounded upwards
                // eg. : if franchise 0, 5, 10, 15, 30 -> 5/2 = 2.5 & rounds to 3
                // Selects value in array (from 0 to 4) -> need to subtract 1 to get correct value
                if(cover.fieldType == "select" && cover.fieldValues.length > 0) {
                    let selectedCapital = Math.round(cover.fieldValues.length/2)
                    cover.capital =  cover.fieldValues[selectedCapital - 1]
                    cover.capitalText =  cover.fieldValuesLiterals[selectedCapital - 1]
                    this.calculateOffer()

                } else {
                    if(cover.coverCode == "") {
                        if(cover.options.length > 0) { 
                            let selectedProduct = Math.round(cover.options.length/2)
                            cover.coverCode =  cover.options[selectedProduct - 1].value
                        }
                    }

                    if(cover.fieldType == "chkcond") {
                        if(cover.coverCategory) {
                            this.setChkCondCoverSelect(cover)
                        } else {
                            this.setChkCondCoverValue(cover)
                        }

                    } else if(cover.fieldType == "chk"){
                        cover.chkCondValue = "1"
                        this.setChkCondCoverValue(cover)

                    } else {
                        let mainCoverCode = cover.coverDepend
                        let mainCover = this.offerCalculated.covers.filter(x => x.coverCode.includes(mainCoverCode))[0]

                        cover.capital = mainCover.capital
                    }
                    this.validateAndCalculateOffer(cover)
                }
                this.activateDependentSwitches(cover)
            }

        },

    

        selectInput(cover){
                
                if(cover.capital != 0) {
                    this.activateDependentSwitches(cover)
                } else {
                    this.deactivateDependentSwitches(cover)
                }
                this.calculateOffer()
        },

        activateDependentSwitches(cover) {
            let mainCoverCode = cover.coverCode
            let coversToModify = []
            // activates next level of dependant covers
            if(cover.capital != "") {

                if(cover.fieldType == "cond" || cover.fieldType == "subs"){
                // Selector type - each option has its code, eg: "INVAVBSPERPRO" (main cover)
                // Dependents - coverDepend on "INV"
                // So, dependent cover must be included in main
                    coversToModify = this.offerCalculated.covers.filter(x => mainCoverCode.includes(x.coverDepend))
    
                } else {
                    coversToModify = this.offerCalculated.covers.filter(x => x.coverDepend == mainCoverCode)
                }
                coversToModify.forEach(element =>{
                    element.switchEnabled = true

                    if(element.fieldType == "auto") {
                        element.switch = true
                    }
                })
            }

       },

       deactivateDependentSwitches(cover) {
        // deactivates covers dependent on the one modifying and looks for the dependent of the ones to be modified - up to 3 levels,
        // to deactivate all

            let mainCoverCode = cover.coverCode

            let firstLevelCovers = []
            let secondLevelCovers = []
            let coversToModify = []

            // Selector type - each option has its code, eg: "INVAVBSPERPRO" (main cover)
            // Dependents - coverDepend on "INV"
            // So, dependent cover must be included in main
            if(cover.fieldType == "cond" || cover.fieldType == "subs"){
                firstLevelCovers = this.offerCalculated.covers.filter(x => mainCoverCode.includes(x.coverDepend))
            } else {
                firstLevelCovers = this.offerCalculated.covers.filter(x => x.coverDepend == mainCoverCode)
            }

            secondLevelCovers = this.checkSecondarySwitches(firstLevelCovers)
            coversToModify = this.checkSecondarySwitches(secondLevelCovers)

            coversToModify.forEach(element =>{
                element.switchEnabled = false
                element.switch = false
                element.capitalText = "0"
                element.capital = 0
            })

       },

        checkSecondarySwitches(coversArray) {
            let additionalCovers = []
            let mainCoverCode = ""

            coversArray.forEach(cover => {
                mainCoverCode = cover.coverCode

                if(cover.fieldType == "cond"){
                    this.offerCalculated.covers.filter(x => mainCoverCode.includes(x.coverDepend)).forEach(subCover => {
                        additionalCovers.push(subCover)
                        })
                } else {
                    this.offerCalculated.covers.filter(x => x.coverDepend == mainCoverCode).forEach(subCover => {
                        additionalCovers.push(subCover)
                        })
                }

            })

            if (additionalCovers != []) {
                additionalCovers.forEach(element => {
                    coversArray.push(element)
                })
            }

            return coversArray
        },

       numberWithCommas(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },

        // callService() {
        //     this.callServicePopup = true;

        // },
        // closeCallServicePopup(value){
        //     this.callServicePopup = value;
        // },
        closeCoverageChartPop(value){
          this.coverageChartPop = value.closePop;
          if (value.packName != "") {

            this.goToThirdStep(value.packName)
          }  else{
            return true
          }
        },
        //  goToPreviusStep() {
        //     this.$router
        //     .push("/"+ this.previus + "-step/" + this.code)
        //     .catch(() => {});

        // },

       getPaymentMethod(){
           let paymentMethod = ""
           switch(this.commercialOffer.paymentMethod){
               case 1:
                   paymentMethod = "año"
                break;

               case 2:
                paymentMethod = "semestre"
                break;

               case 3:
                paymentMethod = "cuatrimestre"
                break;

               case 4:
                paymentMethod = "trimestre"
                break;

               case 6:
                paymentMethod = "bimensual"
                break;

               case 12:
                paymentMethod = "mes"
                break;
           }

           return paymentMethod
        },

        formatImporte(importe){
            if(!isNaN(importe)){
                return Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(importe.toFixed(2));
            }

            return importe;
        },

       setFieldType(type) {
            let response;

            switch(type) {
            case "txt":
                response = "number";
                break;

            case "subs":
                response = "subs_number";
                break;


            case "cond":
                response =  "number";
                break;

            case "select":
                response =  "select";
                break;

            case "chk":
                response =  "checkbox";
                break;

            case "chkcond":
                response =  "chckcond";
                break;

            default:
            response = "number";

            }
            return response;
        },


        makeTitle(name, receipt) {
            return name + ": " + receipt.toFixed(2) + "€/mes"
        },

        NumbersOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) ) {
                // Quitado el punto: && charCode !== 46
                evt.preventDefault();;
            } else {
                return true;
            }
         },

        calculateOffer() {
            this.offerCalculated.profession = this.commercialOfferResponse.profession
            this.offerCalculated.bornDate = this.commercialOfferResponse.age
            this.offerCalculated.regime = this.commercialOfferResponse.regime
            this.offerCalculated.paymentType = this.commercialOffer.paymentMethod
            this.offerCalculated.commercialOfferCode = this.code

            // PARSE CoverCodes to delete "INV_" added to IPP covers
            // If coverCode is not rewritten with INV_, offerCalculated could be directly used
            let data = {
                profession: this.commercialOfferResponse.profession,
                bornDate: this.commercialOfferResponse.age,
                regime: this.commercialOfferResponse.regime,
                paymentType: this.commercialOffer.paymentMethod,
                commercialOfferCode: this.code,
                covers: [],
            }

            this.offerCalculated.covers.forEach(cover => {
                if (cover.period != "") {
                   cover.period  =  parseInt(cover.period)
                }
                if(cover.capital > 0) {
                    cover.capital = parseFloat(cover.capital)
                    data.covers.push(cover)
                }
            })


            if (data.covers.filter(x => x.coverCode.includes("_"))){
                data.covers.filter(x => x.coverCode.includes("_")).forEach(element => {
                    let codeSplit =  element.coverCode.split("_")
                    element.coverCode = codeSplit[1]
                })
            }
            
            // console.log(this.checkCovers(data.covers))
            if(this.checkCovers(data.covers)) {
                this.$http.post(process.env.VUE_APP_BROKER_API + '/commercialOffer-packs', data)
                .then((response) => {
                    //parse & stringify avoids mutation of array when covers change
                    this.previousCovers = JSON.parse(JSON.stringify(data.covers)) 
                    this.offerCalculatedResponse = response.data;

                    this.offerCalculated.primaNeta = 0;
                    this.offerCalculated.taxs = 0;
                    this.offerCalculated.primaTotal = 0;
                    this.offerCalculated.receipt = 0;

                    this.offerCalculated.productCover = this.offerCalculatedResponse.productCover;
                    if (response.data.validate) {

                        this.writePriceResults(response)

                    }

                }).catch((err) => {
                    this.offerCalculated.primaNeta = 0;
                    this.offerCalculated.taxs = 0;
                    this.offerCalculated.primaTotal = 0;
                    this.offerCalculated.receipt = 0;
                    this.$vs.notify({
                    
                        text: 'Introduce el capital en al menos una cobertura para calcular el precio.',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                
                })
            }
        },
       
        checkCovers(newCovers){
            // This function compares previous calculation to new one, if there are a difference in capitals/covers - it calculates
            // Needed due to blur event - if not calculated millions of times when focus is changed (although covers are the same)
            let validateForm = false 

            if(newCovers.length != this.previousCovers.length){
                validateForm = true
            } else {
                newCovers.forEach(element => {
                
                    if(this.previousCovers.filter(a => a.coverCode == element.coverCode)[0]){
                        if( this.previousCovers.filter(a => a.coverCode == element.coverCode)[0].capital != element.capital){
                            validateForm = true
                            return 
                        }
                    } else {
                        validateForm = true
                        return 
                    }
                })

            }

            if(validateForm == true) {
                return true
            } else {
                return false
            }
        },

        validateAndCalculateOffer(coverToChange) {

            // PARSE CoverCodes to delete "INV_" added to IPP covers
            // If coverCode is not rewritten with INV_, offerCalculated could be directly used
            let data = {
                profession: this.commercialOfferResponse.profession,
                bornDate: this.commercialOfferResponse.age,
                regime: this.commercialOfferResponse.regime,
                paymentType: this.commercialOffer.paymentMethod,
                commercialOfferCode: this.code,
                covers: [],
            }

            this.offerCalculated.covers.forEach(cover => {
                if(cover.capital > 0) {

                    if(cover.coverCode == coverToChange.coverCode) {
                        if (coverToChange.period != "") {
                        coverToChange.period  =  parseInt(coverToChange.period)
                        }

                        coverToChange.capital = parseFloat(coverToChange.capital)
                        data.covers.push(coverToChange)

                    } else {
                        if (cover.period != "") {
                        cover.period  =  parseInt(cover.period)
                        }
        
                        cover.capital = parseFloat(cover.capital)
                        data.covers.push(cover)
                    }
                }
            })

            if (data.covers.filter(x => x.coverCode.includes("_"))){
                data.covers.filter(x => x.coverCode.includes("_")).forEach(element => {
                    let codeSplit =  element.coverCode.split("_")
                    element.coverCode = codeSplit[1]
                })
            }
            if(this.checkCovers(data.covers)) {
                this.$http.post(process.env.VUE_APP_BROKER_API + '/commercialOffer-packs', data)
                .then((response) => {
                    
                    if(response.data.validate){
                        //parse & stringify avoids mutation of array when covers change
                        this.previousCovers = JSON.parse(JSON.stringify(data.covers)) 

                        this.offerCalculatedResponse = response.data;     
                        this.offerCalculated.covers.filter(a => a.coverCode == coverToChange.coverCode)[0].capital = coverToChange.capital
                        this.offerCalculated.covers.filter(a => a.coverCode == coverToChange.coverCode)[0].capitalText = coverToChange.capital.toString()

                        this.offerCalculated.primaNeta = 0;
                        this.offerCalculated.taxs = 0;
                        this.offerCalculated.primaTotal = 0;
                        this.offerCalculated.receipt = 0;

                        this.offerCalculated.productCover = this.offerCalculatedResponse.productCover;

                        this.writePriceResults(response)
                        
                    } else {
                        this.offerCalculatedResponse.errorsInfo = response.data.errorsInfo;     
                        this.offerCalculatedResponse.validate = response.data.validate;     
                        
                        if(response.data.errorCoverCode){
                            let faultyCode = response.data.errorCoverCode
                            this.offerCalculated.covers.filter(x => x.coverCode == faultyCode)[0].capital = 0
                            this.offerCalculated.covers.filter(x => x.coverCode == faultyCode)[0].capitalText = "0"
                        }
                    }
                })
            }
        },


        writePriceResults(response){
          
            this.offerCalculated.covers.forEach(cover => {
                if (response.data.coversResult.filter(x => x.productCover == cover.coverCode)[0]) {

                    cover.primaNeta = response.data.coversResult.filter(x => x.productCover == cover.coverCode)[0].primaNeta;
                    cover.tax = response.data.coversResult.filter(x => x.productCover == cover.coverCode)[0].taxs;
                } else {
                    cover.primaNeta = 0;
                    cover.tax = 0
                }
            });

            this.offerCalculated.covers.forEach(cover => {
                if (cover.capital == 0){

                    cover.primaNeta = 0;
                    cover.tax = 0;
                }

            });
                response.data.coversResult.forEach(element => {
                if (element.primaNeta){

                    this.offerCalculated.primaNeta = this.offerCalculated.primaNeta + element.primaNeta;
                    this.offerCalculated.taxs = this.offerCalculated.taxs + element.taxs;
                    this.offerCalculated.primaTotal = this.offerCalculated.primaTotal + element.primaTotal;
                    this.offerCalculated.receipt = this.offerCalculated.receipt + element.receipt;
                }
            });
        },

        getErrors(){

            if (this.offerCalculatedResponse.validate == false) {

                this.offerCalculated.covers.forEach(cover => {
                    if (cover.capital == 0){

                        cover.primaNeta = 0;
                        cover.tax = 0;
                    }
                });
            }
         },

         showCoverageChart(){

            if (this.offerCalculatedResponse.validate == true){

                this.dataTablePackage = [];

                    let param = {
                        name:"",
                        receipt:"",
                        paymentMethod:"",
                    }

                    param.name = this.commercialOffer.name
                    param.receipt = this.offerCalculated.receipt
                    param.paymentMethod = this.offerCalculated.paymentType
                    this.dataTablePackage.push(param)

                    let params = {
                    name: "",
                    coverages: []

                    }

                    params.name = this.code;
                    this.offerCalculated.covers.forEach(element => {
                        let cover = {
                            coverCode: "",
                            capital: 0,
                            productId: ""
                        }
                        cover.capital = parseInt(element.capital);
                        cover.productId = element.productId;

                        // PARSE CoverCodes to delete "INV_" added to IPP covers
                        if(element.coverCode.includes("_")){
                            let coverSplit = element.coverCode.split('_')
                            cover.coverCode = coverSplit[1]
                        } else {
                            cover.coverCode = element.coverCode;
                        }

                        params.coverages.push(cover);
                    });

                    this.$http.post(process.env.VUE_APP_BROKER_API + '/coverage-chart-pack', params)
                    .then((responseCoverageChart) => {
                        this.coveragechart = responseCoverageChart.data;
                        this.coverageChartPop = true;
                    })
            }
        },

        goToThirdStep() {
            this.calculateOffer();
            this.getErrors();

            if (this.offerCalculatedResponse.validate){

                this.$vs.loading({ type: "sound"});

            let params = {
                commercialOfferCode: this.commercialOfferResponse.commercialCode,
                commercialOfferType: this.commercialOffer.type,
                leadType: "BasicVendor",
                profession: this.commercialOfferResponse.profession,
                regime: this.commercialOfferResponse.regime,
                packName: this.commercialOffer.literal,
                primaNeta: 0,
                primaTotal: 0,
                packCovers: []
                }

                // add commercialOffer generic files selected
                if(this.commercialOffer.filesId){
                    this.commercialOffer.filesId.forEach(file => {
                        this.files.push(file)
                    })
                }

                let products = [];

                this.offerCalculated.covers.forEach(element => {
                    if(element.capital != 0){
                        if(!products.includes(element.productId)){
                            products.push(element.productId)

                        }
                    }
                })
               
                this.dataStored.productsSelected = products

                params.primaNeta =  parseFloat(this.offerCalculated.receipt.toFixed(2)),
                params.primaTotal =  parseFloat(this.offerCalculated.primaTotal.toFixed(2))
                this.offerCalculated.covers.forEach(cover => {
                    if (cover.capital > 0) {
                        let coverToSend = {
                            capital: 0,
                            coverCode: "",
                            cover: "",
                            productCover: "",
                            productName: ""
                        }
                        coverToSend.capital = cover.capital

                        if(cover.coverCode.includes("_")){
                            let codeSplit =  element.coverCode.split("_")
                            cover.coverCode = codeSplit[1]
                        } 

                        coverToSend.coverCode = cover.coverCode
                        coverToSend.productCover = cover.productId + "_" + cover.coverCode

                        let productSelected = this.commercialOffer.productsInfo.filter(x => x._id == cover.productId)[0]
                        coverToSend.productName = productSelected.nombre
                        coverToSend.cover = productSelected.coberturas.filter(z => z.codigo == coverToSend.coverCode)[0].nombre

                        params.packCovers.push(coverToSend)

                        let coverData = {
                            capital: 0,
                            coverCode: "",
                            product: "",
                            productId: "",
                        }

                        coverData.capital = cover.capital
                        coverData.coverCode = coverToSend.coverCode
                        coverData.product = cover.productId
                        coverData.productId = cover.productId

                        this.packCommercialOffers.push(coverData)
                    }
                })

                this.dataStored.packCommercialOffers = this.packCommercialOffers
                this.dataStored.offerCalculated = this.offerCalculated
                
                this.filter = '{ "_id": {$in: [';
                products.forEach( product => {
                    this.filter += ' ObjectId("' + product + '"),';
                })
                this.filter += "]}}"

                let headers = {
                    "Content-Type": "application/json",
                    filter: this.filter
                }
                    

                this.$http.get(process.env.VUE_APP_BROKER_API + '/products', { headers })
                .then((response) => {
                    response.data.forEach(product => {
                        // add product files
                        
                        if (product.requestId && !this.files.includes(product.requestId)) {
                            this.files.push(product.requestId)
                        }
                    })

                    this.dataStored.filesToSign = this.files
                    // this.dataStored.productsSelected = products

                    this.$http.patch(process.env.VUE_APP_BROKER_API + '/initial-data/' + this.commercialOfferResponse.initialDataId, params)
                    .then((response) => {

                        localStorage.setItem(this.code, JSON.stringify(this.dataStored))
                        this.$router
                        .push("/" + this.next + "-step/" + this.code)
                        .catch(() => {});
                        
                    })
                })

            }
                   
        },

        includeCommas(number) {

            if(number.capitalText.includes(".")){

                let numbersSplit = number.capitalText.split(".")
                let numbersJoined = ""
                numbersSplit.forEach(element => {
                    numbersJoined = numbersJoined + element
                })
                number.capital = parseInt(numbersJoined)
                number.capitalText = numbersJoined.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

            } else {

                number.capital = parseInt(number.capitalText)
                number.capitalText =  number.capitalText.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            }

            return number
        },

        focusOff() {
        
        // DO NOT DELETE THIS EMPTY FUNCTION.
        // On IOS, the input does not loose focus when pressed enter or on the screen 
        // This causes problems when inputing value, as it does not calculate and does not allow to do anything after
        // Need an empty extra button on the screen, so when clicked outside, looses focus of button & calculates

        }
        

    },

}
</script>
<style lang="scss">

#multiple-products {
    // Something overflows (a div) - to avoid sideways scroll
    overflow: hidden !important;

    .tooltip .tooltiptext {
        bottom: 110%;
        padding: 1px 1px;
        margin-left: -115px;
        width: 185px;
    }


    .align {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 5px;
    }

    .titles {
        display: flex !important;
        flex-direction:column;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
        align-items: stretch;
    }

    div[comma-value]{
    position:relative;
    }
    div[comma-value]:before{
        content: attr(comma-value);
        position:absolute;
        left:0;
    }
    div[comma-value] input{
        color:#fff;
    }

    #titles {
        img{
            width: 70px;
            height: 70px;
            display:block;
            margin:auto;
            }
    }

    // #contractButton {
    //     display: inline;
    //     padding: 5px 10px !important;
    //     background: none;
    //     color: rgba(var(--vs-secundary), 1) !important;
    //     border: 1px solid rgba(var(--vs-secundary), 1) !important;
    //     font-weight: bold;
    //     border-radius: 18px;
    //     float: right !important;
    //     font-size: 12px !important;
    //     margin-top: 20px !important;
    //     margin-right:30px !important;
    //     margin-bottom:20px !important;
    //     height: 40px;
    // }  
    
    .label-switch{
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .vs-switch{
            margin-right: 10px;

        }
    }

    .question-label{
        display: flex;
        margin-right: 10px;
    }
    

    // .more-info{
    //     font-style: normal;
    //     font-size:25px !important;
    //     font-weight:bold;
    //     float: left !important;
    //     color:rgba(var(--vs-secundary), 1) !important;
    //     opacity: 1;
    //     cursor: pointer;
    //     border: none !important;
    //     margin-top: 20px !important;
    //     margin-left:30px !important;
    //     margin-bottom:20px !important;

    // :hover {
    //     font-size:28px !important;
    //     }
    // }

    .image {
        width: 60px;
        height: 60px;
        display:block;
        margin:auto;
    }

    .condSelector{
        max-width: 200px !important;
    }


    .md-icon {
        min-width: 20px;
        width: 20px;
    }

    .select-filter {
        .md-input{
            font-size: 14px !important;
        }
        .vs__dropdown-toggle {
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;
        }
    }

    .select-filter  .vs__dropdown-menu {
    z-index: 10000 !important;
    }

    .product {
        padding-left: 20px;
        padding-right: 20px;

        .vs-col .vs-col {
          width: 100%;
        }
        .md-list-item-container {
            font-size:11px !important;
        }
    }

    .input-capital {
        text-align: right !important;
        padding-bottom: 0px;
        color:red;
        }

    .answer-cell {
        div.md-field{
            padding-top:0px;
            min-height: 15px;
        }
        .md-input {
            text-align: end;
        }
        max-width:120px;
        min-width: 120px !important;
    }

    @media only screen and (max-width : 450px){
        .question-label{
            width:100%;
        }

        .product{
            text-align: left !important;
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            align-items: stretch;
            margin-top: 15px;
        }

        .answer-cell{
            margin: auto !important;
        }

        .label-switch{
            .vs-switch{
                margin-right: 0px;
            }
        } 

        .condSelector{
            max-width: 200px !important;
            margin: auto !important;
        }
        .vx-row .vx-col {
            padding: 0 0rem;
            
            .config-cell{
                
                #label{
                    font-size: 14px;
                    margin-top: 5px;
                    width: 100%;
                    margin-left: 10px;
                }
                #franchise-selector{
                    width: 90px
                }
                #period-selector{
                    width: 90px
                }
                width: 100%;
                display: flex;
                flex-direction: column;
                flex-wrap: nowrap;
                align-content: center;
                justify-content: space-around;
                align-items: center;
                margin-bottom: 5px;
                
                .md-field{
                    margin: 0px 0px 3px;
                    min-height: 0px !important;
                    padding-top: 0px;
                    .md-input{
                        font-size: 14px !important;
                        }
                }
            }
        }

    }

   
    @media screen and (min-width : 451px)
      and (max-width : 600px) {
        .call-button{
            .vs-button{
                float: center !important;
            }
        }

        .question-cell {
            width:80%;
            padding-left:0px;
            padding-right:0px;
            margin-top:10px;
        }

        .vx-row .vx-col {
        padding: 0 0rem;
            .config-cell{
                #label{
                    width: 200px
                }
                #franchise-selector{
                    width: 90px
                }
                #period-selector{
                    width: 90px

                }
                width: 90%;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-content: center;
                justify-content: flex-start;

                align-items: flex-end;
                margin-bottom: 10px;
            }
        }

        .product {
            text-align: left !important;
            margin-bottom: 12px;
        }

        .product .price {
        text-align: right !important;
        }

        input.v-search {
            text-align: left !important;
        }
      }


    @media screen and (min-width : 601px)
      and (max-width : 759px) {

        .question-cell {
            width:80% !important;
            padding-left:0px;
            padding-right:0px;
            margin-top:10px;
        }

        .vx-row .vx-col {
        padding: 0 0rem;
            .config-cell{
                #label{
                    width: 250px
                }
                #franchise-selector{
                    .md-input{
                        text-align: start;
                    }
                    width: 100px
                }
                #period-selector{
                    .md-input{
                        text-align: start;
                    }

                    width: 100px

                }
                width: 90%;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-content: center;
                justify-content: flex-start;
                align-items: flex-end;
                margin-bottom: 10px;
            }
        }

        .product {
            text-align: left !important;
            margin-bottom: 12px;
        }

        .product .price {
        text-align: right !important;
        }
        
        .call-button{
            .vs-button{
                float: right !important;
            }
        }

        input.v-search {
            text-align: left !important;
        }

    }

    @media only screen and (min-width : 760px)
  and (max-width : 1100px) {


        .question-cell {
            width:80% !important;
            padding-left:0px;
            padding-right:0px;
        }

        .vx-row .vx-col {
            padding: 0 0rem;
            .config-cell{
                #label{
                    width: 250px
                }
                #franchise-selector{
                    .md-input{
                        text-align: start;
                    }
                    width: 100px

                }
                #period-selector{
                    .md-input{
                        text-align: start;
                    }
                    width: 100px
                }
                width: 90%;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-content: center;
                justify-content: flex-start;
                align-items: flex-end;
                }
            }

        .product {
            text-align: left !important;
            margin-bottom: 12px;
        }

        .product .price {
        text-align: right !important;
        }

        .condSelector{
            max-width: 250px !important;
        }

        .call-button{
            .vs-button{
                float: right !important;
            }
        }

        input.v-search {
            text-align: left !important;
        }

       .select-answer-filter.vs__selected-options{
            flex-grow: 1;
            flex-direction: row;
            align-items: center;
            justify-content: space-around;
        }
    }

    @media screen and (min-width: 1101px) {

        .question-cell {
            width:80% !important;
            padding-left:0px;
            padding-right:0px;

        }

        .vx-row .vx-col {
            padding: 0 0rem;
            .config-cell{
                #label{
                    width: 250px

                }
                #franchise-selector{
                    .md-input{
                        text-align: start;
                    }
                    width: 100px
                }
                #period-selector{
                    .md-input{
                        text-align: start;
                    }
                    width: 100px
                }
                width: 90%;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-content: center;
                justify-content: flex-start;
                align-items: flex-end;
                }
            }

        .call-button{
            .vs-button{
                float: right !important;
            }
        }

        .product {
            text-align: left !important;
            margin-bottom: 12px;
        }

        .product .price {
        text-align: right !important;
        }

        .condSelector{
            max-width: 250px !important;
        }

        .select-answer-filter.vs__selected-options{
            flex-grow: 1;
            flex-direction: row;
            align-items: center;
            justify-content: space-around;
        }
    }
}
</style>